import { Form, Popover } from "antd";
import { HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { PassengerIcon, DownIcon } from "src/assets/Icons";
import GuestsSelectionContent from "../../GuestsSelectionContent/GuestsSelectionContent";

type RoomType = { adults: number; children: number; childrenAges: number[] };

export default function GuestsSelectionWeb() {
  const { t } = useTranslation();
  const rooms: RoomType[] = Form.useWatch("rooms") ?? [];
  const adultsCount = rooms.reduce((acc, r) => acc + (r.adults || 0), 0);
  const childrenCount = rooms.reduce((acc, r) => acc + (r.children || 0), 0);
  const displayValue = t("Hotels.search.roomsAndGuests", { rooms: rooms.length || 1, guests: adultsCount + childrenCount });

  return (
    <Popover
      arrow={false}
      trigger={["click"]}
      placement="bottom"
      forceRender
      content={<GuestsSelectionContent className="md:w-95 w-80 p-3" listClassName="max-h-[220px]" />}
    >
      <div className={cn("flex w-full cursor-pointer items-center gap-2 font-semibold text-font-minimal whitespace-nowrap md:justify-center md:p-3! hover:text-font-active")}>
        <PassengerIcon />
        {displayValue}
        <span className="hidden h-5 w-5 items-center justify-center md:flex">
          <DownIcon />
        </span>
      </div>
    </Popover>
  );
}
